import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { capitalize, printdDate } from '../helper.js';
import View from './View';

class editProductView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Edit Product View Error Message';
  _message = 'Edit Product View Success Message';

  addHandlerEditProduct(handler) {
    const productForm = document.querySelector('.product__form--update');
    if (!productForm) return;

    const btnUpdate = document.querySelector('.product__form--update--btn');

    productForm.addEventListener('submit', function (e) {
      e.preventDefault(); // just blocks the default action (such as submitting a form or navigating to another URL)
      e.stopImmediatePropagation(); // prevents the event from bubbling up the DOM tree and prevents any other event handlers on the same element from being executed. It disables multiple submission trigger.
      btnUpdate.disabled = true;
      btnUpdate.textContent = 'Updating...'; // Update text for feedback

      const form = new FormData(this);

      handler(form, 'formData');
    });
  }

  _generateMarkup() {
    const product = this._data;

    return `
        <form action="#" class="product__form--upload product__form--update"  >
          <div class="product__form--fields">
            <label for="">In Stock:</label>
            <div class="product__form--fields">
              <p>
                <label for="yes">Yes</label>
                <input type="radio" id="yes" name="inStock" value=true ${product.inStock ? `checked` : ``} />
              </p>

              <p>
                <label for="no">No</label>
                <input type="radio" id="no" name="inStock" value=false ${!product.inStock ? `checked` : ``}/>
              </p>
            </div>
          </div>
          <div class="product__form--fields">
            <label for="name">Product Name:</label>
            <input type="text" id="name" name="name" value="${product.name}"/>
          </div>

          <div class="product__form--fields">
            <label for="brand">Brand:</label>
            <input type="text" id="brand" name="brand" value="${product.brand}"/>
          </div>

          <div class="product__form--fields">
            <label for="tag">Tagline:</label>
            <input type="text" id="tag" name="tag" value="${product.tag}" />
          </div>



          <div class="product__form--fields">
            <label for="description">Description:</label>
            <input type="text" id="description" name="description" value="${product.description}"/>
          </div>

          <div class="product__form--fields">
            <label for="">Gender:</label>
            <div class="product__form--fields">
              <p>
                <label for="male">Male:</label>
                <input type="checkbox" id="male" name="gender" value="male" ${product.gender?.includes('male') ? `checked` : ``}/>
              </p>
              <p>
                <label for="female">Female:</label>
                <input type="checkbox" id="female" name="gender" value="female"  ${product.gender?.includes('female') ? `checked` : ``}/>
              </p>
            </div>
          </div>

          <div class="product__form--fields">
            <label for="">Made For:</label>
            <div class="product__form--fields">
              <p>
                <label for="kids">Kids:</label>
                <input type="checkbox" id="kids" name="madeFor" value="kids"  ${product.madeFor?.includes('kids') ? `checked` : ``}/>
              </p>
              <p>
                <label for="adults">Adults:</label>
                <input
                  type="checkbox"
                  id="adults"
                  name="madeFor"
                  value="adults"
                  ${product.madeFor?.includes('adults') ? `checked` : ``}
                />
              </p>
              <p>
                <label for="olds">Olds:</label>
                <input type="checkbox" id="olds" name="madeFor" value="olds" ${product.madeFor?.includes('olds') ? `checked` : ``}/>
              </p>
            </div>
          </div>

          <div class="product__form--fields">
            <label for="sizes">Available Sizes:</label>
            <input type="text" id="sizes" name="sizesAvailable" value="${product.sizesAvailable?.length > 0 ? `${product.sizesAvailable.join(', ')}` : ``}"/>
          </div>

          <div class="product__form--fields">
            <label for="mrp">MRP:</label>
            <input type="text" id="mrp" name="mrp" value="${product.mrp ? product.mrp : ``}"/>
          </div>

          <div class="product__form--fields">
            <label for="price">Selling Price:</label>
            <input type="text" id="price" name="price" value="${product.price ? product.price : ``}"/>
          </div>

          <div class="product__form--fields">
            <label for="image-cover">Cover Image:</label>
            <input
              type="file"
              accept="image/*"
              id="image-cover"
              name="imageCover"
            />
          </div>

          <div class="product__form--fields">
            <label for="images">Product Images:</label>
            <input
              type="file"
              accept="image/*"
              id="images"
              name="images"
              multiple
            />
          </div>

          <div class="product__form--fields">
            <label for="material">Material:</label>
            <input type="text" id="material" name="material"  value="${product.material ? product.material : ``}"/>
          </div>

          <div class="product__form--fields">
            <label for="care">Care:</label>
            <input type="text" id="care" name="care"  value="${product.care?.length > 0 ? product.care.join(', ') : ``}"/>
          </div>

          <div class="product__form--fields">
            <label for="use-case">How to use:</label>
            <input type="text" id="use-case" name="useCase"  value="${product.useCase ? product.useCase : ``}"/>
          </div>

          <div class="product__form--fields">
            <label for="features">Features:</label>
            <input type="text" id="features" name="features"  value="${product.features?.length > 0 ? product.features.join(', ') : ``}"/>
          </div>

          <div class="product__form--fields">
            <label for="package-contains">Package Contains:</label>
            <input
              type="text"
              id="package-contains"
              name="packageContains"
              value="${product.packageContains?.length > 0 ? product.packageContains.join(', ') : ``}"
            />
          </div>

          <div class="product__form--upload--btn-container">
            
             <button type="submit" class="product__upload product__form--update--btn">
              Update
            </button> 
          </div>

          <p class="paragraph paragraph__small">#${product._id} | Created By: ${capitalize(product.createdBy.name)} (${capitalize(product.createdBy.role)}) on ${printdDate(product.createdAt, true)}</p>

        </form>

`;
  }
}

export default new editProductView();
